import { apiClient } from './apiClient';

export interface MaintenanceOperationInfo {
  id: string;
  name: string;
  description: string;
  category: string;
  isIdempotent: boolean;
}

export interface TenantOperationResult {
  tenantId: string;
  tenantName: string;
  success: boolean;
  status: string;
  error?: string;
}

export interface MaintenanceExecutionResult {
  operationId: string;
  operationName: string;
  success: boolean;
  tenantsProcessed: number;
  tenantsSucceeded: number;
  tenantsFailed: number;
  tenantResults: TenantOperationResult[];
}

class DatabaseMaintenanceService {
  async getOperations(): Promise<MaintenanceOperationInfo[]> {
    const response = await apiClient.get('/api/databasemaintenance/operations');
    return response.data;
  }

  async executeOperation(operationId: string): Promise<MaintenanceExecutionResult> {
    const response = await apiClient.post(`/api/databasemaintenance/execute/${operationId}`);
    return response.data;
  }
}

export const databaseMaintenanceService = new DatabaseMaintenanceService();
